import { Box, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import { slackSaasKeys } from "../../../../api/queryKeys";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";
import useExpandedList from "../../../../components/hooks/ExpandedList";
import LoadingIcon from "../../../../components/LoadingIcon";
import { logos } from "../../environment/icons/iconExport";
import Guideline from "../components/Guideline";
import GuidelineStep from "../components/GuidelineStep";
import GuidelineStepByStep from "../components/GuidelineStepByStep";
import IntegrationGuideAlert from "../components/IntegrationGuideAlert";

export default function SlackSaasIntegration() {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);
  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  const { isIntegrated, isIntegratedLoading } = useIsIntegrated("slack_saas");
  const { handleExpandAll, handleCollapseAll } = useExpandedList();

  const { fetchSlackSaaSAuthUrl } = useAPI();

  const slackAuthUrl = useQuery({
    queryKey: slackSaasKeys.authUrl(),
    queryFn: fetchSlackSaaSAuthUrl,
    select: (response) => response.data,
    enabled: !isIntegrated,
  });

  const loading = isIntegratedLoading || slackAuthUrl.isLoading;

  return (
    <Box>
      <Guideline
        title={!isIntegrated ? "Integrate with Slack" : ""}
        image={logos.SlackLogo}
        name={"Slack SaaS"}
        content={
          loading ? (
            <LoadingIcon size={25} />
          ) : isIntegrated && !guideMode ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Typography variant={"h4"}>
                Slack integration successful!
              </Typography>
            </Box>
          ) : (
            <>
              <Box mb="20px">
                <Grid container spacing={2} direction={"row"}>
                  {guideMode && <IntegrationGuideAlert />}

                  <Grid item>
                    <SecondaryButton onClick={handleExpandAll}>
                      Expand All Screenshots
                    </SecondaryButton>
                  </Grid>
                  <Grid item>
                    <SecondaryButton onClick={handleCollapseAll}>
                      Collapse All Screenshots
                    </SecondaryButton>
                  </Grid>
                </Grid>
              </Box>
              <GuidelineStepByStep>
                <GuidelineStep title="Login with a user account that has the necessary permissions to add the Slack application to the Slack workspace"></GuidelineStep>
                <GuidelineStep title="Add the Breeze App to Slack">
                  <Box style={{ display: "flex" }}>
                    <PrimaryButton
                      onClick={() => {
                        window.open(slackAuthUrl.data, "_blank");
                      }}
                      disabled={guideMode}
                    >
                      Add to Slack
                    </PrimaryButton>
                  </Box>
                </GuidelineStep>
                <GuidelineStep title="Approve the application addition request on Slack"></GuidelineStep>
              </GuidelineStepByStep>
            </>
          )
        }
      />
    </Box>
  );
}
